module.exports = __webpack_public_path__ + "static/img/11_1Intro_2_Kaprow_Tape_Score_1957_FPO.15c8fe3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/kaprow/images/11_1Intro_2_Kaprow_Tape_Score_1957_FPO.jpg
// module id = d2Ek
// module chunks = 0